module.exports = __webpack_public_path__ + "static/me-99e4d8d26815bee91f995784027b06d4.jpg";